import "./lib/instrument";
import ReactDOM from "react-dom/client";
import App from "./App";
import './index.css'

const root = document.getElementById("root") as HTMLElement;

ReactDOM.createRoot(root).render(
  <App/>
)
